/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {ChangeEvent, useCallback} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {BulkSettingFieldValues, GenericObject, SCIPendingSettings} from '@ion/core/src/types/entities';
import {FormItem} from '@ion/dls/src/components/forms/FormItem';
import Dropdown from '@ion/dls/src/components/menus/Dropdown';
import RadioButton from '@ion/dls/src/components/radio/RadioButton';
import Switch from '@ion/dls/src/components/switch/Switch';
import {BodyTypography} from '@ion/dls/src/typography/BodyTypography';
import {reportingIntervalInitialVal} from './SCISettingsUtils';

export interface SCIAdvanceControlsMenuProps {
  field: GenericObject;
  classes: {
    [key: string]: string;
  };
  noUpdate: boolean;
  handleAdvanceFieldChange: Function,
  menu: string;
  value: any;
  activeTab: number;
  advanceDelayOptions: Array<any>;
  reportAndLogOptions: Array<any>;
  initialAdvance: boolean;
  sciPendingSettingData: SCIPendingSettings;
  bulkSCI?: boolean;
}

const dropDownStyle = {
  width : '33%'
};
/**
 * View or Edit Advance Sub Menus related information of an SCI device
 */
export const SCIAdvanceControlsMenu = ({
  field,
  classes,
  noUpdate,
  menu,
  value,
  activeTab,
  handleAdvanceFieldChange,
  advanceDelayOptions,
  reportAndLogOptions,
  initialAdvance,
  sciPendingSettingData,
  bulkSCI = false
}: SCIAdvanceControlsMenuProps) => {
  const dropdownOptions = activeTab === 0 ? advanceDelayOptions : reportAndLogOptions;
  const isSettings: boolean = (
    field.label !== translate('admin-devices:view.sciSettings.stationaryReportingdelay') &&
    field.label !== translate('admin-devices:view.sciSettings.loggingPeriod')
  );
  const handleDropdownChange = useCallback(({target}: ChangeEvent<HTMLInputElement>) => {
    handleAdvanceFieldChange(target?.value, field, activeTab);
  }, [handleAdvanceFieldChange]);

  const getRadioField = (field, value) => {
    return (
      <>
        <RadioButton label
          checked={value}
          value={BulkSettingFieldValues.on}
          onChange={function(e) { handleAdvanceFieldChange(e, field, activeTab); }}/>
        <RadioButton label
          checked={value === null}
          value={BulkSettingFieldValues.default}
          onChange={function(e) { handleAdvanceFieldChange(e, field, activeTab); }}/>
        <RadioButton label
          checked={value === false}
          value={BulkSettingFieldValues.off}
          onChange={function(e) { handleAdvanceFieldChange(e, field, activeTab); }}/>
      </>
    );
  };

  const dropDownValue = initialAdvance ? sciPendingSettingData[menu] : value;
  if (isSettings) {
    return (
      <FormItem fullWidth>
        <div className={classes.actionsTile}>
          <BodyTypography className={classes.overridesReportTitle}>
            {field.label}
          </BodyTypography>
          {!bulkSCI
            ? <Switch disabled={noUpdate}
              name={field.label}
              onChange={function(e) {
                handleAdvanceFieldChange(!value, field, activeTab);
              }}
              checked={field.label === 'GPS' ? !value : value}/>
            : getRadioField(field, value)}
        </div>
      </FormItem>
    );
  }
  return (
    <FormItem fullWidth>
      <div className={classes.actionsTile}>
        <BodyTypography className={classes.overridesReportTitle}>
          {field.label}
        </BodyTypography>
        <div style={dropDownStyle}>
          <Dropdown displaySelectedLabel
            options={dropdownOptions}
            value={reportingIntervalInitialVal(menu, dropDownValue, bulkSCI)}
            disabled={noUpdate}
            onChange={handleDropdownChange}/>
        </div>
      </div>
    </FormItem>
  );
};

export default SCIAdvanceControlsMenu;
